<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZuanCai`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.3174 5.34242L8.32551 9.31555L10.656 10.1342C11.2529 10.344 11.6525 10.9078 11.6525 11.5405V12.8007L17.1129 8.13212V6.21822L14.3174 5.34242ZM18.176 9.48342L11.3517 15.3181C11.1108 15.524 10.7761 15.5806 10.4809 15.4652L9.46171 15.0669V17.5917L12.1828 18.6125L19.3687 12.1468V9.8348L18.176 9.48342ZM7.74381 16.9473L4.63129 15.7796V13.4214L5.58113 12.8099C5.67826 13.3031 6.02066 13.7222 6.50103 13.9099L7.74381 14.3956V16.9473ZM5.55306 10.7848V9.55375C5.55306 9.2658 5.69734 8.99701 5.93732 8.83788L13.4583 3.85083C13.8326 3.6026 14.299 3.53643 14.7276 3.67071L17.7859 4.62882C18.4077 4.8236 18.8308 5.39964 18.8308 6.05118V7.88544L20.0173 8.23499C20.6513 8.42179 21.0866 9.0038 21.0866 9.66476V12.2481C21.0866 12.6707 20.9072 13.0735 20.593 13.3561L13.2292 19.9819C12.8158 20.354 12.2295 20.4648 11.7087 20.2695L8.30107 18.9911L3.88037 17.3327C3.29871 17.1145 2.91339 16.5584 2.91339 15.9371V13.2974C2.91339 12.7906 3.1709 12.3185 3.59702 12.0442L5.55306 10.7848ZM9.93456 13.4073V11.7016L7.27095 10.7659V12.3664L9.93456 13.4073Z"/></svg>
</template>
<script>

export default {
  name: 'IconZuanCai',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
